import { ReactNode } from 'react';
import Grid from '@mui/material/Grid';

import { useMaterialUIController } from '@context/MDContext';
import { MDBox, MDTypography, DefaultNavbar } from '@components/index';

interface Props {
  header?: ReactNode;
  title?: string;
  description?: string;
  children: ReactNode;
  illustration?: string;
  isError?: boolean;
}

// interface RoutesType {
//   [key: string]:
//     | ReactNode
//     | string
//     | {
//         [key: string]: string | any;
//       }[];
// }
[];

function LoginLayout({
  header,
  title,
  description,
  illustration,
  children,
  isError = false
}: Props): JSX.Element {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  // const getRoutes = (routeData: SignInRoute): RoutesType => ({
  //   ...routeData,
  //   icon: <FontAwesomeIcon icon={routeData.icon} />
  // });

  return (
    <MDBox
      width='100vw'
      height='100%'
      minHeight='100vh'
      bgColor={'white'}
      sx={{ overflowX: 'hidden' }}
    >
      <DefaultNavbar
        routes={[]}
        action={{
          type: 'external',
          route: 'https://www.datasquirrel.ai/',
          label: 'DataSquirrel Website',
          color: 'info'
        }}
        showFeedbackIcon
      />
      <Grid
        container
        sx={{
          backgroundColor: ({ palette: { background, white } }) =>
            darkMode ? background.default : white.main
        }}
      >
        <Grid item xs={12} lg={6}>
          <MDBox
            display={{ xs: 'none', lg: 'flex' }}
            width='calc(100% - 2rem)'
            height='calc(100vh - 2rem)'
            borderRadius='lg'
            ml={2}
            mt={2}
            sx={{
              backgroundImage: `url(${illustration})`,
              backgroundSize: 'cover'
            }}
          />
        </Grid>
        <Grid item xs={11} sm={8} md={6} lg={4} xl={3} sx={{ mx: 'auto' }}>
          <MDBox
            display='flex'
            flexDirection='column'
            justifyContent='center'
            height='100vh'
          >
            <MDBox pt={3} px={3} textAlign='center'>
              {!header ? (
                <>
                  <MDBox mb={1} textAlign='center'>
                    <MDTypography
                      variant='h2'
                      color={isError ? 'error' : 'secondary'}
                      textGradient
                    >
                      {title}
                    </MDTypography>
                  </MDBox>
                  <MDTypography variant='h5' color={isError ? 'error' : 'info'}>
                    {description}
                  </MDTypography>
                </>
              ) : (
                header
              )}
            </MDBox>
            <MDBox p={3}>{children}</MDBox>
          </MDBox>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default LoginLayout;
